module.exports = __webpack_public_path__ + "static/media/29EUNOG16.c2aff670.jpg";